import { ActionPermissionModal } from 'components'
import { constant } from 'constants';
import { Images } from 'constants';
import { UserContext } from 'context';
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom';
// import Images from "./images";

const EbillExtentionModal = (props) => {
    const { isOpen, onClose, messageType, templateId, templateData } = props;
    const { masterData } = useContext(UserContext)
    // const template = constant?.PERMISSION_TEMPLATES?.[messageType]?.[templateId];

    // if (!template) {
    //     console.warn(`No template found for messageType=${messageType}, templateId=${templateId}`);
    //     return null;
    // }

    // const { image, title, description, callToAction, highlight, features, icon } = template;
    const navigate = useNavigate()

    const modifyProps = {
        ...props,
    };

    return (
        <>
            <ActionPermissionModal {...modifyProps}>
                <div className="dynamic-permission-modal">
                    {templateData?.web_image && <img
                        src={`${masterData?.s3_url}${templateData?.web_image}`}
                        alt=""
                        style={{ width: "100%" }}
                    />}

                    <div className="__ebillModal_fx" style={{ padding: '15px' }}>
                        <div style={{ paddingLeft: "10px" }}>
                            {/* Heading */}
                            {templateData?.heading && <h4>{templateData?.heading}</h4>}

                            {/* Description */}
                            {templateData?.description && <p style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                flexWrap: "wrap",
                                marginBottom: "10px"
                            }}>{templateData?.description}</p>}

                            {/* Sub Description with Crown */}
                            {templateData?.sub_description && <p
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    flexWrap: "wrap",
                                    marginBottom: "10px"
                                }}
                            >
                                <img src={Images.crownIcon.default} alt="" />
                                <span
                                    style={{ color: "#ff512eff", fontWeight: "700" }}
                                >
                                    {templateData?.sub_description}
                                </span>
                            </p>}
                        </div>

                        {/* Feature List */}
                        {templateData?.content?.length > 0 && (
                            <div className="__ebillModal_fx_list">
                                <ul>
                                    {templateData.content.map((feature, idx) => (
                                        <li
                                            key={idx}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                            }}
                                        >
                                            <img src={Images.verifyIcon.default} alt="✓" />
                                            <span>{feature}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        <div style={{ marginTop: "20px", textAlign: "center" }}>
                            {templateData?.redirect_action == 1 && <button
                                style={{
                                    backgroundColor: "#1a73e8",
                                    color: "#fff",
                                    padding: "12px 20px",
                                    borderRadius: "8px",
                                    border: "none",
                                    fontWeight: "600",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    width: "100%",
                                }}
                                onClick={()=>navigate("/subscription")}
                            >
                                Upgrade Plan
                            </button>}

                            {templateData?.contact_action == 1 && <p
                                style={{
                                    marginTop: "12px",
                                    cursor: "pointer",
                                    color: "#1a73e8",
                                    fontWeight: "500",
                                }}
                                onClick={templateData?.onSalesClick}
                            >
                                {templateData?.contact_text}
                            </p>}
                        </div>
                    </div>
                </div>
            </ActionPermissionModal>
        </>
    )
}

export default EbillExtentionModal
